<template>
  <div style="padding: 16px;">
    <el-card body-style="height: 100%;">
      <el-table
        v-loading="pageLoading"
        :data="audits"
        :default-sort="{prop: 'obj_num', order: 'ascending'}"
        :height="windowHeight - 200"
        @row-click="showAudit"
        @sort-change="changeOrder"
      >
        <el-table-column
          :fixed="$mq == 'xs' || $mq == 'sm' ? false : 'left'"
          sortable
          prop="id"
          label="#"
          width="70"
          align="center"
        />
        <el-table-column
          prop="username"
          label="Username"
          min-width="150"
        />
        <el-table-column
          prop="event"
          label="Action"
          min-width="150"
        />
        <el-table-column
          prop="auditable_type"
          label="Class"
          min-width="150"
        />
        <el-table-column
          prop="auditable_id"
          label="Class ID"
          min-width="150"
        />
        <el-table-column
          prop="created_at"
          label="Timestamp"
          min-width="150"
        />
      </el-table>
      <el-pagination
        style="line-height: 12px; margin-top: 16px;"
        background
        layout="prev, pager, next"
        :page-count="lastPage"
        @current-change="changePage"
        @prev-click="changePage"
        @next-click="changePage"
      />
    </el-card>
    <el-dialog
      title="Audit"
      :visible.sync="dialogVisible"
      @close="closeAudit"
      width="80%"
    >
      <nxs-audit-view  :audit="tempAudit"/>
    </el-dialog>
  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import nxsAuditView from "../shared/Audit.vue";

export default {
    components: {nxsAuditView},
    data () {
        return {
            audits: null,
            dialogVisible: false,
            tempAudit: null,
            page: 1,
            lastPage: 1,
            pageLoading: true,
            order: "desc"
        };
    },
    computed: {...mapFields(["user", "permissions"])},
    created () {
        if (!this.$store.getters.hasPermission(["Auditing-All", "Auditing-Index"]))
            this.$router.push("/admin");
    },
    mounted () {
        this.pullAudits();
    },
    methods: {
        changeOrder (set) {
            this.audits = [];
            this.pageLoading = true;
            if (set.order == "ascending") {
                this.order = "asc";
            } else {
                this.order = "desc";
            }
            this.pullAudits();
        },
        changePage (newPage) {
            this.page = newPage;
            this.pullAudits();
        },
        showAudit (audit) {
            this.tempAudit = audit;
            this.dialogVisible = true;
        },
        closeAudit () {
            this.dialogVisible = false;
            this.tempAudit = null;
        },
        pullAudits () {
            this.pageLoading = true;
            this.axios
                .get("/api/v1/audits?page=" + this.page + "&order=" + this.order, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.audits = response.data.data;
                    this.lastPage = response.data.last_page;
                    this.pageLoading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
        }
    }
};
</script>
